// Fixed, z-index-lifted overlay shared by both access-denied variants: the
// legacy shell (#wrapper) paints over the static #react-root, so an in-flow
// screen would render behind it, invisible. Shared so the two can't drift.
export const accessDeniedOverlaySx = {
    position: 'fixed',
    top: '50%',
    left: 0,
    width: '100%',
    transform: 'translateY(-50%)',
    zIndex: theme => theme.zIndex.drawer - 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}
